import { render, staticRenderFns } from "./CotPropostaAccessoValutazioneUvmPage.vue?vue&type=template&id=faf03390"
import script from "./CotPropostaAccessoValutazioneUvmPage.vue?vue&type=script&lang=js"
export * from "./CotPropostaAccessoValutazioneUvmPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports